import { Panel } from 'react-resizable-panels';

interface IDocumentContainerProps {
	children: React.ReactNode;
	className?: string;
	verticalScroll?: boolean;
}

const DocumentContainer: React.FunctionComponent<IDocumentContainerProps> = ({
	children,
	className,
	verticalScroll
}) => {
	const overflow = verticalScroll ? 'hidden auto' : 'hidden';
	return (
		<Panel className={className} style={{ display: 'flex', flexDirection: 'column', overflow: overflow }}>
			{children}
		</Panel>
	);
};

export default DocumentContainer;
